<template>
  <div v-if="this.isExperienceEditor || this.shouldDisplay">
    <v-app-bar
      :fixed="loggedIn"
      :flat="true"
      :height="headerHeight"
      class="app-header"
      :class="{
        'logged-in': loggedIn,
        'desktop-header': $vuetify.breakpoint.lgAndUp,
        'tablet-header': $vuetify.breakpoint.sm || $vuetify.breakpoint.md,
        'mobile-header': $vuetify.breakpoint.xsOnly,
      }"
    >
      <!-- This is if we want to use nested placeholder and split this into sub components: Logo, Links, menu... -->
      <sc-placeholder name="jssheaderleft" :rendering="rendering" />
      <v-spacer></v-spacer>
      <sc-placeholder
        name="jssheaderright"
        :rendering="rendering"
        class="full-height align-center d-flex flex-row"
      />
    </v-app-bar>
    <div v-if="loggedIn" :style="`height:${headerHeight};`"></div>
  </div>
</template>

<script>
import headerConfig from '../../lib/headerConfig';
import { isExperienceEditorActive, Placeholder } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'Header',
  data() {
    return {
      challengerURL: headerConfig.challengerURL,
      challengerPhoneNumber: headerConfig.challengerPhoneNumber,
      appURL: headerConfig.iolURL,
      contactURL: headerConfig.contactURL,
      loggedIn: false,
    };
  },
  props: {
    rendering: {
      type: Object,
    },
    params: {
      type: Object,
    },
  },
  components: {
    ScPlaceholder: Placeholder,
  },
  mounted() {
    this.onUrlChange();
  },
  updated() {
    this.onUrlChange();
  },
  computed: {
    contactIconVisible() {
      return this.$vuetify.breakpoint.smAndUp;
    },
    isExperienceEditor() {
      // Todo may need to add other check like preview mode in SC editor...
      return isExperienceEditorActive();
    },
    headerHeight() {
      if (this.$vuetify.breakpoint.lgAndUp) {
        return '72px';
      }
      return '54px';
    },
    shouldDisplay() {
      if (this.params) {
        if (
          (typeof this.params.DisplayWhenLoggedIn == 'undefined' ||
            this.params.DisplayWhenLoggedIn !== '1') &&
          !this.loggedIn
        ) {
          return true;
        } else if (this.params.DisplayWhenLoggedIn == '1' && this.loggedIn) {
          return true;
        }
      }
      return false;
    },
  },
  methods: {
    async onUrlChange() {
      if (typeof this.$auth != 'undefined') {
        const isAuthenticated = await this.$auth.isAuthenticated();
        const user = await this.$auth.userDetails;
        if (isAuthenticated && user.hasAgreedChallengerTerms) {
          this.loggedIn = true;
        } else {
          this.loggedIn = false;
        }
      }
    },
  },
};
</script>
<style>
.desktop-header .v-toolbar__content {
  max-width: 1170px;
}
.app-header .v-toolbar__content {
  padding: 0;
  margin-right: auto;
  margin-left: auto;
}
.tablet-header .v-toolbar__content {
  max-width: 738px;
}
.tablet-header.logged-in .v-toolbar__content {
  max-width: 720px;
}

.mobile-header .v-toolbar__content {
  padding: 0 16px;
}
/* Sitecore Experience editor */
.scEnabledChrome .app-header .scEmptyPlaceholder {
  width: 100px;
  height: 50px;
}
</style>
<style lang="scss" scoped>
.app-header {
  padding-bottom: 20px;
  @media print {
    display: none;
  }
  box-shadow: 0px 1px 0px #cfcfcf !important;
  background: map-deep-get($colors, 'white', 'base') !important;
}

/* Sitecore Experience Editor */
.scEnabledChrome .app-header {
  position: relative;
  top: unset;
}
.column-left {
  align-self: center;
}

::v-deep {
  .chl_logo {
    height: 40px;
    @media #{map-get($display-breakpoints, 'md-and-down')} {
      height: 31px;
    }
  }
  .iol_logo {
    height: 20px;
    @media #{map-get($display-breakpoints, 'md-and-down')} {
      height: 16px;
    }
    @media #{map-get($display-breakpoints, 'xs-only')} {
      display: none;
    }
  }

  .logged-in .iol_logo {
    display: block;
  }
  .full-height {
    height: 100%;
  }
  a {
    color: map-deep-get($colors, 'blue-text', 'base') !important;
    &:hover {
      color: map-deep-get($colors, 'blue-title', 'base') !important;
      text-decoration: none;
    }
    &:hover:before {
      opacity: 0 !important;
    }
  }
  .v-btn:hover .v-icon {
    color: map-deep-get($colors, 'blue-title', 'base') !important;
  }
  .v-btn {
    font-size: 1.25rem !important;
    background-color: transparent !important;
    font-weight: map-get($font-weights, 'normal') !important;
    letter-spacing: 0ch;
    @media #{map-get($display-breakpoints, 'md-and-down')} {
      font-size: 1rem !important;
    }
  }
  .v-btn.mdi-phone {
    margin-right: 6px;
    @media #{map-get($display-breakpoints, 'md-and-down')} {
      margin-right: 0;
    }
  }
  .v-btn.mdi-email-outline {
    min-width: unset !important;
    .v-icon {
      margin-right: 0px;
    }
    @media #{map-get($display-breakpoints, 'md-and-down')} {
      padding-right: 0 !important;
    }
  }
}

.mobile-header .column-right {
  &::v-deep {
    .chl_logo {
      height: 400px;
    }
    .v-list-item__title {
      display: none;
    }
    .v-list-item {
      padding: 0 8px;
    }
    .v-list-item__icon {
      margin-right: 0px;
    }
  }
}
</style>
